import { axiosInstance } from "./axiosInstance";

export const CategoryProgramService = {
  getAll: async () => {
    return await axiosInstance.get('/api/feature/membership/main-program-category');
  },
  create: async (data) => {
    return await axiosInstance.post('/api/feature/membership/main-program-category', data);
  },
  update: async (id, data) => {
    return await axiosInstance.post(`/api/feature/membership/main-program-category/update/${id}`, data);
  },
  delete: async (id) => {
    return await axiosInstance.delete(`/api/feature/membership/main-program-category/delete/${id}`);
  },
  getMainProgram: async () => {
    return await axiosInstance.get(`/api/feature/category/get-main-program-category`);
  },
}